export default "__VITE_ASSET__CtMVJVFu__"